import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {deriveStepUiSchema} from 'pipelines/generalized-step-config-editor/step-config-settings/deriveStepUiSchema';
import {getStepTypeConfigShape} from 'pipelines/StepShapeUtils';

import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';

const CREATE_ENTITIES_BASE_UI_SCHEMA = deriveStepUiSchema(
  getStepTypeConfigShape(PipelineStepType.CREATE_ENTITIES, 0).fields
);

export const CREATE_ENTITIES_V0_UI_SCHEMA = {
  ...CREATE_ENTITIES_BASE_UI_SCHEMA,
  folderId: {
    ...CREATE_ENTITIES_BASE_UI_SCHEMA.folderId,
    fieldSettings: {
      // Entities can't be registered directly into a registry root; execution rejects it.
      showRegistries: false,
    },
  },
} as StepTypeConfigUISchemaV2<PipelineStepType.CREATE_ENTITIES, 0>;
